export const LIST_SUMMARY_PROJECT_REQUEST = 'LIST_SUMMARY_PROJECT_REQUEST'
export const LIST_SUMMARY_PROJECT_SUCCESS = 'LIST_SUMMARY_PROJECT_SUCCESS'
export const LIST_SUMMARY_PROJECT_FAIL = 'LIST_SUMMARY_PROJECT_FAIL'

export const LIST_SUMMARY_PACKAGE_REQUEST = 'LIST_SUMMARY_PACKAGE_REQUEST'
export const LIST_SUMMARY_PACKAGE_SUCCESS = 'LIST_SUMMARY_PACKAGE_SUCCESS'
export const LIST_SUMMARY_PACKAGE_FAIL = 'LIST_SUMMARY_PACKAGE_FAIL'

export const LIST_PARTNER_SERVICE_TYPE_REQUEST = 'LIST_PARTNER_SERVICE_TYPE_REQUEST'
export const LIST_PARTNER_SERVICE_TYPE_SUCCESS = 'LIST_PARTNER_SERVICE_TYPE_SUCCESS'
export const LIST_PARTNER_SERVICE_TYPE_FAIL = 'LIST_PARTNER_SERVICE_TYPE_FAIL'

export const DELETE_PARTNER_SERVICE_TYPE_REQUEST = 'DELETE_PARTNER_SERVICE_TYPE_REQUEST'
export const DELETE_PARTNER_SERVICE_TYPE_SUCCESS = 'DELETE_PARTNER_SERVICE_TYPE_SUCCESS'
export const DELETE_PARTNER_SERVICE_TYPE_FAIL = 'DELETE_PARTNER_SERVICE_TYPE_FAIL'

export const DETAIL_PARTNER_SERVICE_TYPE_REQUEST = 'DETAIL_PARTNER_SERVICE_TYPE_REQUEST'
export const DETAIL_PARTNER_SERVICE_TYPE_SUCCESS = 'DETAIL_PARTNER_SERVICE_TYPE_SUCCESS'
export const DETAIL_PARTNER_SERVICE_TYPE_FAIL = 'DETAIL_PARTNER_SERVICE_TYPE_FAIL'

export const DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_REQUEST = 'DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_REQUEST'
export const DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_SUCCESS = 'DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_SUCCESS'
export const DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_FAIL = 'DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_FAIL'